import { FilterStorageVersion, Search } from "../../../filtering";
import { MyEventListItem } from "../../../fms.data/models/MyEventListItem";
import { JobNames } from "../../../framework.core/JobNames";
import { SuntekSettings, SystemSettings, User } from "../../../ifmsTypes";
import * as XCol from '../../../framework.core/XExportColumn';
import AbstractListView, { 
  DataFetchResult, 
  ExportRowRenderer, 
  ListCustomFilterRenderer, 
  ListOrderBy, 
  ListRowRenderer 
} from "../../common/AbstractListView";
import { 
  DateRenderer, 
  DateTimeRenderer, 
  TextAlignLeftRenderer, 
  TextAlignRightRenderer, 
  TextRenderer 
} from "../../../uiControls/SmartTableRenderers";
import { useContext, useEffect, useState } from "react";
import JobListViewContext, { IJobListViewContext } from "../../common/JobListViewContext";
import { formatDate, nowDate } from "../../../dateUtils";
import { TableColumn, TableSettings } from "../../../tableSettings";
import { myEventList } from "../tableSettings";
import IfmsModal from "../../../ui/IfmsModal";
import SecondaryButton from "../../../ui/SecondaryButton";
import Tracking_Y_Triangle from '../../../img/Tracking_Y_Triangle.svg';
import Tracking_B_Triangle from '../../../img/Tracking_B_Triangle.svg';
import MyEvent_AN from '../../../img/MyEvent_AN.svg';
import MyEvent_Carrier from '../../../img/MyEvent_Carrier.svg';
import MyEvent_Cust from '../../../img/MyEvent_Cust.svg';
import MyEvent_Pickup from '../../../img/MyEvent_Pickup.svg';
import MyEvent_Return from '../../../img/MyEvent_Return.svg';
import MyEvent_Billings from '../../../img/MyEvent_Billings.svg';
// import container_tracking_black from '../../../img/container_tracking-black.svg';
// import container_tracking_white from '../../../img/container_tracking-white.svg';
// import container_tracking from '../../../img/container_tracking.svg';
// import container_tracking_blue from '../../../img/container_tracking-blue.svg';
// import container_tracking_red from '../../../img/container_tracking-red.svg';
// import container_tracking_green from '../../../img/container_tracking-green.svg';
// import container_tracking_yellow from '../../../img/container_tracking-yellow.svg';
import { SQLField, SQLInfo, SQLType } from "../../../framework.core/data/SQLInfo";
import useSuntekSettings from "../../../hooks/useSuntekSettings";
import InfoAreaDrawer from "../../../uiControls/infoArea/InfoAreaDrawer";
import PrimaryButton from "../../../ui/PrimaryButton";
import { useHistory } from "react-router";
import { NavigationType, openNewPage } from "../../../util/navigationHelpers";
import UsersDropDown from "../../../uiControls/UsersDropDown";
import Select from "../../../ui/Select";
import { IApplicationContext } from "../../../ApplicationContext";
import { SearchModelBase } from "../../../fms.data/models/SearchModelBase";
import IfmsDate from "../../../ui/Date";
import fastStorage from "../../../fastStorage";
import _ from "lodash";
import { useAppSelector } from "../../../app/hooks";

const events = {
  AnSent: "A/N Sent",
  CarrierRel: "Carrier Rel",
  CustRel: "Cust Rel",
  Pickup: "Demurrage",
  EmpRTN: "Detention",
  Billings: "Billings",
};

async function DoSave(row: any, dataIndex: any, datePopupInputValue: string|null, appContext: any) {
  let fieldName = '';
  let sqlInfos: SQLInfo[] = [];
  
  if (dataIndex === "anSentDate") {
    await appContext.api.updateANSentInfo(Number(row.hblId), datePopupInputValue);
    return;
  } else if (dataIndex === "customsRlsDate") {
    const sqlInfo = new SQLInfo ({
      tableName: "T_OIHMAIN",
      type: SQLType.Update,
      fields: [
        new SQLField({ fieldName: "F_ClearDate", propertyName: "clearDate", value: datePopupInputValue }),
        new SQLField({ fieldName: "ClearBy", propertyName: "clearBy", value: datePopupInputValue ? appContext.user?.id??'': '' })
      ],
      key: new SQLField({ fieldName: "F_ID", propertyName: "Id", value: row.hblId })
    });
    sqlInfos.push(sqlInfo);
  } else {
    switch (dataIndex) {
      case "lastFreeDay":
        fieldName = "F_LastFreeDay";
        break;
      case "vesselArrivalDate":
        fieldName = "F_ATA";
        break;
      case "unloadVesselDate":
        fieldName = "F_UnloadDate";
        break;
      case "railDepartureDate":
        fieldName = "F_RATD";
        break;
      case "railArrivalDate":
        fieldName = "F_RATA";
        break;
      case "carrierRlsDate":
        fieldName = "F_CarrierRLS";
        break;
      case "pickupAvailableDate":
        fieldName = "F_PUDATE";
        break;
      case "pickupDate":
        fieldName = "F_OutDate";
        break;
      case "emptyCntrRtnDate":
        fieldName = "F_EmptyReturn";
        break;
    }

    // Update MBL Container
    let sqlInfo: SQLInfo = new SQLInfo ({
      tableName: 'T_OIMCONTAINER',
      type: SQLType.Update,
      fields: [
        new SQLField({ fieldName, propertyName: dataIndex, value: datePopupInputValue })
      ],
      key: new SQLField({ fieldName: "F_Id", propertyName: "Id", value: row.mCntrId })
    });
    sqlInfos.push(sqlInfo);

    // MBL에 Carrier Release 필드 값이 없는 경우 업데이트
    if (!row.mblCarrierRlsDate && dataIndex === "carrierRlsDate") {
      sqlInfo = new SQLInfo ({
        tableName: "T_OIMMAIN",
        type: SQLType.Update,
        fields: [
          new SQLField({ fieldName: "F_RLSDate", propertyName: "rlsDate", value: datePopupInputValue }),
          new SQLField({ fieldName: "rlsby", propertyName: "rlsDateBy", value: datePopupInputValue ? appContext.user?.id??'': '' })
        ],
        key: new SQLField({ fieldName: "F_ID", propertyName: "Id", value: row.mblId })
      });
      sqlInfos.push(sqlInfo);
    } 
  }
  await appContext.api.updateContainerInfos(sqlInfos);
}

function ClickAbleDateRenderer({ cell, data, row }: any) {
  const jobListContext = useContext(JobListViewContext);
  const suntekSettings = useSuntekSettings();
  const l = data[row.index];

  function onDateCellClick() {
    if (cell.column.dataIndex === "billingsDate") return;

    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(l.id);
    jobListContext.setClickedCell(cell);
  }

  let imgSrc = null;
  let content: React.ReactNode = <></>;
  const additionalStyle: React.CSSProperties = { display: 'flex', width: '98%', paddingLeft: '5px' };

  if (cell.value) {
    content = formatDate(cell.value);
  } else {
    switch (cell.column.dataIndex) {
      case "anSentDate":
        if (l.eta && suntekSettings.myEvent?.enableAN) {
          if (l.anPastDays > 0) {
            // additionalStyle.border = 'solid 1px red';
            imgSrc = Tracking_Y_Triangle;
          } else {
            imgSrc = Tracking_B_Triangle;
          }
          content = l.anPastDays;
        }
        break;
      case "carrierRlsDate":
        if (l.vesselArrivalDate && suntekSettings.myEvent?.enableCarrierRls) {
          if (l.carrierRlsPastDays > 0) {
            // additionalStyle.border = 'solid 1px red';
            imgSrc = Tracking_Y_Triangle;
          } else {
            imgSrc = Tracking_B_Triangle;
          }
          content = l.carrierRlsPastDays;
        } else if (l.eta && suntekSettings.myEvent?.enableCarrierRlsFromEta) {
          if (l.carrierRlsFromEtaPastDays > 0) {
            // additionalStyle.border = 'solid 1px red';
            imgSrc = Tracking_Y_Triangle;
          } else {
            imgSrc = Tracking_B_Triangle;
          }
          content = l.carrierRlsFromEtaPastDays;
        }
        break;
      case "customsRlsDate":
        if (l.vesselArrivalDate && suntekSettings.myEvent?.enableCustomsRls) {
          if (l.customsRlsPastDays > 0) {
            // additionalStyle.border = 'solid 1px red';
            imgSrc = Tracking_Y_Triangle;
          } else {
            imgSrc = Tracking_B_Triangle;
          }
          content = l.customsRlsPastDays;
        } else if (l.eta && suntekSettings.myEvent?.enableCustomsRlsFromEta) {
          if (l.customsRlsFromEtaPastDays > 0) {
            // additionalStyle.border = 'solid 1px red';
            imgSrc = Tracking_Y_Triangle;
          } else {
            imgSrc = Tracking_B_Triangle;
          }
          content = l.customsRlsFromEtaPastDays;
        }
        break;
      case "pickupDate":
        if (l.unloadVesselDate && suntekSettings.myEvent?.enableDemurrage) {
          if (l.demurragePastDays > 0) {
            // additionalStyle.border = 'solid 1px red';
            imgSrc = Tracking_Y_Triangle;
          } else {
            imgSrc = Tracking_B_Triangle;
          }
          content = l.demurragePastDays;
        }
        break;
      case "emptyCntrRtnDate":
        if (l.pickupDate && suntekSettings.myEvent?.enableDetention) {
          if (l.detentionPastDays > 0) {
            // additionalStyle.border = 'solid 1px red';
            imgSrc = Tracking_Y_Triangle;
          } else {
            imgSrc = Tracking_B_Triangle;
          }
          content = l.detentionPastDays;
        }
        break;
      case "billingsDate":
        if (l.emptyCntrRtnDate && suntekSettings.myEvent?.enableBilling) {
          if (l.billingPastDays > 0) {
            // additionalStyle.border = 'solid 1px red';
            imgSrc = Tracking_Y_Triangle;
          } else {
            imgSrc = Tracking_B_Triangle;
          }
          content = l.billingPastDays;
        }
        break;
    }
  }

  if (imgSrc) {
    return (
      <div style={additionalStyle} onClick={onDateCellClick}>
        <img style={{ paddingTop: '2px' }} height="13px" src={imgSrc} alt='' />
        <div style={{ paddingLeft: '5px' }}>{content}</div>
      </div>
    );
  } 

  return (
    <div className="ifms-table-default" style={{ width: '100%', minHeight: '16px', cursor: 'pointer' }} onClick={onDateCellClick}>{content}</div>
  );
}

function ExportEventDate(accessor : string, value: any, appContext : IApplicationContext) {
  const suntekSettings = appContext?.suntekSettings ? appContext.suntekSettings : {};
  const data = value[accessor];

  if (!!data) {
    return formatDate(data);
  } else {
    switch (accessor) {
      case "anSentDate":
        if (value['eta'] && suntekSettings.myEvent?.enableAN) {
          if (value['anPastDays'] > 0) {
            return '↑' + value['anPastDays']
          } else {
            return '↓' + value['anPastDays']
          }
        }
        break;
      case "carrierRlsDate":
        if (value['vesselArrivalDate'] && suntekSettings.myEvent?.enableCarrierRls) {
          if (value['carrierRlsPastDays'] > 0) {
            return '↑' + value['carrierRlsPastDays']
          } else {
            return '↓' + value['carrierRlsPastDays']
          }
        } else if (value['eta'] && suntekSettings.myEvent?.enableCarrierRlsFromEta) {
          if (value['carrierRlsFromEtaPastDays'] > 0) {
            return '↑' + value['carrierRlsFromEtaPastDays']
          } else {
            return '↓' + value['carrierRlsFromEtaPastDays']
          }
        }
        break;
      case "customsRlsDate":
        if (value['vesselArrivalDate'] && suntekSettings.myEvent?.enableCustomsRls) {
          if (value['customsRlsPastDays'] > 0) {
            return '↑' + value['customsRlsPastDays']
          } else {
            return '↓' + value['customsRlsPastDays']
          }
        } else if (value['eta'] && suntekSettings.myEvent?.enableCustomsRlsFromEta) {
          if (value['customsRlsFromEtaPastDays'] > 0) {
            return '↑' + value['carrierRlsFromEtaPastDays']
          } else {
            return '↓' + value['customsRlsFromEtaPastDays']
          }
        }
        break;
      case "pickupDate":
        if (value['unloadVesselDate'] && suntekSettings.myEvent?.enableDemurrage) {
          if (value['demurragePastDays'] > 0) {
            return '↑' + value['demurragePastDays']
          } else {
            return '↓' + value['demurragePastDays']
          }
        }
        break;
      case "emptyCntrRtnDate":
        if (value['pickupDate'] && suntekSettings.myEvent?.enableDetention) {
          if (value['detentionPastDays'] > 0) {
            return '↑' + value['detentionPastDays']
          } else {
            return '↓' + value['detentionPastDays']
          }
        }
        break;
      case "billingsDate":
        if (value['emptyCntrRtnDate'] && suntekSettings.myEvent?.enableBilling) {
          if (value['billingPastDays'] > 0) {
            return '↑' + value['billingPastDays']
          } else {
            return '↓' + value['billingPastDays']
          }
        }
        break;
    }
  }
}

function MyEventRender({ cell, data, row}: any) {
  const l = data[row.index];

  return (
    <div title={l.eventStatus} style={{ marginLeft: '5px' }}>
        { l.eventStatus.includes(events.AnSent) && <img style={{ paddingTop: '1px', paddingBottom: '1px', marginRight: '3px' }} height="18px" src={MyEvent_AN} alt='' />}
        { l.eventStatus.includes(events.CarrierRel) && <img style={{ paddingTop: '1px', paddingBottom: '1px', marginRight: '3px' }} height="18px" src={MyEvent_Carrier} alt='' />}
        { l.eventStatus.includes(events.CustRel) && <img style={{ paddingTop: '1px', paddingBottom: '1px', marginRight: '3px' }} height="18px" src={MyEvent_Cust} alt='' />}
        { l.eventStatus.includes(events.Pickup) && <img style={{ paddingTop: '1px', paddingBottom: '1px', marginRight: '3px' }} height="18px" src={MyEvent_Pickup} alt='' />}
        { l.eventStatus.includes(events.EmpRTN) && <img style={{ paddingTop: '1px', paddingBottom: '1px', marginRight: '3px' }} height="18px" src={MyEvent_Return} alt='' />}
        { l.eventStatus.includes(events.Billings) && <img style={{ paddingTop: '1px', paddingBottom: '1px', marginRight: '3px' }} height="18px" src={MyEvent_Billings} alt='' />}
    </div>
  );
}

function HyperLinkTextRenderer({ cell, data, row }:any) {
  const history = useHistory();
  const l = data[row.index];
  let url = "";

  if (cell.column.dataIndex === "mblNo") {
    if (l.mblId > 0) url = `/oceanImport/mbl/view/${l.mblId}`;
  } else if (cell.column.dataIndex === "hblNo") {
    if (l.hblId > 0) url = `/oceanImport/hbl/view/${l.hblId}`;
  }

  function openLink() {
    if (!url) return;
    
    openNewPage(history, url, NavigationType.newPage);
  }

  const additionalStyle = {
    width: '100%',
    color: url ? 'blue' : undefined,
    cursor: url ? 'pointer' : undefined,
    fontWeight: url ? 600 : undefined,
  };

  return (
      <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left" style={additionalStyle} onClick={openLink}>
        {cell.value}
      </div>
  );
}

function ListCommands({ useDarkMode, preparedBy } : { useDarkMode: boolean, preparedBy: string }) {
  const storage = useAppSelector(x => x.storage);
  
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);
  const [searchItems, setSearchItems] = useState({preparedBy, warning: '' });
  const filterOrdersStorageKey = `filter-order-${FilterStorageVersion}-${history.location.pathname}${history.location.search}`;
  const filterOrderStorage = storage[filterOrdersStorageKey];
  

  useEffect(() =>{
    if (!jobListContext.search.general1 && !jobListContext.search.general2) {
      setSearchItems({ preparedBy, warning: '' })
    } else {
      setSearchItems({ preparedBy: jobListContext.search.generalText1, warning: jobListContext.search.generalText2 });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobListContext.search.version]);

  function onSearch() {
    setSearchModel(searchItems, jobListContext, filterOrderStorage);
    openNewPage(history, `/common/joblistview/MYEVT/myEvent`, NavigationType.newPage);
  }

  return (
    <div style={{ display: 'flex', width: '500px'}}>
      <span style={{ width: '110px', fontSize: '11px', fontWeight: 'bold', textAlign: 'right', paddingLeft: '20px', paddingRight: '20px', color: useDarkMode? 'white' : 'black' }}>Prepared by</span>
      <div className="ifms-input-ctr-row3" style={{ width:'100px' }}>
          <UsersDropDown
            selectId='myevent-list-preparedBy'
            value={searchItems.preparedBy}
            onChange={userId => setSearchItems({...searchItems, preparedBy: userId})}
          />
      </div>

      <span style={{ width: '90px', fontSize: '11px', fontWeight: 'bold', textAlign: 'right', paddingLeft: '20px' , paddingRight: '20px', color: useDarkMode? 'white' : 'black' }}>Event</span>
      <div className="ifms-input-ctr-row3" style={{ width:'120px' }}>
        <Select
          selectId='myevent-list-event'
          value={searchItems.warning}
          onChange={e => setSearchItems({...searchItems, warning: e.target.value??''})}
          items={[
            { value: '', label: '' }, 
            { value: events.AnSent, label: 'A/N Sent' }, 
            { value: events.CarrierRel, label: 'Carrier Rel.'}, 
            { value: events.CustRel, label: 'Cust Rel.'}, 
            { value: events.Pickup, label: 'Demurrage'}, 
            { value: events.EmpRTN, label: 'Detention'}, 
            { value: events.Billings, label: 'Billings'}, 
          ]}
        />
      </div>
      <div style={{ marginLeft:'15px', width:'100px' }}>
        <PrimaryButton name='myevent-list-search-button' size="regular" onClick={onSearch}>Search</PrimaryButton>
      </div>
    </div>
  );
}

function ListToolbar() {
  return null;
}

function ListViewExtras() {
  const jobListContext = useContext(JobListViewContext);
  
  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.MyEvent}
      jobId={(jobListContext.selectedElement as MyEventListItem|null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

function ContainerPopup({ onClose, cell, save }: { onClose: any, cell: any, save: any }) {
  const [datePopupInputValue, setDatePopupInputValue] = useState<string | null>(nowDate());
  
  function setFocus() {
    const focusNode = document.getElementById('myevent-list-datetime');
    if (focusNode) {
      focusNode.focus();
    }
  }

  return (
    <IfmsModal isBlueHeader cancelOnEsc onCancel={onClose} onAfterOpen={setFocus} draggable isOpen title={`Input - ${cell.column.text}`} width="310px">
      <div className='report-popup'>
        <div style={{ height: '30px', display: 'flex' }}>
          <span>{cell.column.text}</span>
          <div style={{ width: '80px', marginLeft: '10px', marginTop: '-1px' }}>
            {/* <DateTime
              dateId="myevent-list-datetime"
              value={datePopupInputValue}
              onChange={date => { setDatePopupInputValue(date ?? null) }}
            /> */}
            <IfmsDate
              value={formatDate(datePopupInputValue)}
              onChange={date => { setDatePopupInputValue(date ?? null) }}
            />
          </div>
        </div>
        <div className="report-footer" >
          <SecondaryButton size="regular" focusable={true} onClick={() => { save(cell.column.dataIndex, datePopupInputValue) }}>
            SAVE
          </SecondaryButton>&nbsp;&nbsp;
          <SecondaryButton size="regular" focusable={true} onClick={onClose}>
            CANCEL
          </SecondaryButton>
        </div>
      </div>
    </IfmsModal>
  );
}

// Filter 동작
// - Prepared by : general1에 고정 
// - Event : general2에 고정
// - 그 외 검색 조건은 general3, extra에 할당
function setSearchModel(searchItems: any, jobListContext: IJobListViewContext, filterOrderStorage:any): Partial<SearchModelBase> {
  const filterOrderObj = [];
  let search = {...jobListContext.search, version: jobListContext.search.version + 1 };

  search.general1 = 'preparedBy';
  search.generalText1 = searchItems.preparedBy;
  filterOrderObj.unshift({
    columnId: 'preparedBy', slot: 'general1', type: 'general', label: 'Prepared By', value: search.generalText1 });

  search.general2 = 'eventStatus';
  search.generalText2 = searchItems.warning;
  filterOrderObj.unshift({ 
    columnId: 'eventStatus', slot: 'general2', type: 'general', label: 'Event', value: search.generalText2 });

  if (filterOrderStorage) {
    const extraSearch = filterOrderStorage.filter((x: any) => x.columnId !== 'eventStatus' && x.columnId !== 'preparedBy');
    if (extraSearch && extraSearch.length > 0) {
      filterOrderObj.unshift(...extraSearch);
    }
  }

  let searchModel = MyEventListItem.calculateSearchParameters(search, MyEventListItem.MapSearchFields);

  jobListContext.setFilterForSearchModel('/common/joblistview/MYEVT/myEvent', searchModel as SearchModelBase, filterOrderObj);

  return searchModel;
}

class MyEventListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number, opType: string|undefined, user: User, jobListContext: IJobListViewContext): Promise<DataFetchResult> {
    let searchModel = null;
    
    // 최초 상단 My Event 메뉴를 클릭하거나 My Event List Tab > ResetFilter 아이콘을 클릭하면 리스트를 초기화 시킨다.
    if ((!search.general1 && !search.general2)) {
      let preparedBy = user?.id??'';
      if (user?.isSuntekAdmin) {
        preparedBy = '';
      }
      searchModel = setSearchModel({ preparedBy, warning:'' }, jobListContext, null);
    } else { 
      searchModel = MyEventListItem.calculateSearchParameters(search, MyEventListItem.MapSearchFields);
    }
    if (searchModel === null) {
      searchModel = new MyEventListItem();
    }

    const apiResult = await api.getListItems(
      JobNames.MyEvent,
      'MyEventListItem',
      searchModel,
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,);

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return { data: apiResult.entities, totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number, opType: string|undefined,  user: User, jobListContext: IJobListViewContext): Promise<Array<any>> {

    let searchModel = null;
    
    // 최초 상단 My Event 메뉴를 클릭하거나 My Event List Tab > ResetFilter 아이콘을 클릭하면 리스트를 초기화 시킨다.
    if ((!search.general1 && !search.general2)) {
      let preparedBy = user?.id??'';
      if (user?.isSuntekAdmin) {
        preparedBy = '';
      }
      searchModel = setSearchModel({ preparedBy, warning:'' }, jobListContext, null);
    } else { 
      searchModel = MyEventListItem.calculateSearchParameters(search, MyEventListItem.MapSearchFields);
    }
    if (searchModel === null) {
      searchModel = new MyEventListItem();
    }


    const apiResult = await api.getListItems(
      JobNames.MyEvent,
      'MyEventListItem',
      searchModel,
      pageNum,
      limit,
      pageSize,
      pagePerBatch,);

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return apiResult.entities;
  }


  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
    ];
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings, listCount: number, useDarkMode: boolean): ListRowRenderer[] {
    return MyEventListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      const additionalStyle: React.CSSProperties = { display: 'flex', padding: '2px 0px 0px', width:'100%', height:'100%', alignContent:'center', justifyContent: 'center'};
      
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Date) {
        if (x.dataIndex === "eta" || x.dataIndex === "trDate")
          colRenderer.Cell = DateRenderer
        else {
          colRenderer.Cell = ClickAbleDateRenderer
        }
      } 
      else if (x.dataIndex === "mblNo" || x.dataIndex === "hblNo") {
        colRenderer.Cell = HyperLinkTextRenderer;
      }
      // else if (x.dataIndex === "te") {
      //   // colRenderer.Cell = (props:any) => <TrRender {...props} useDarkMode={useDarkMode}  />
      //   colRenderer.Cell = TeRender;
      // } 
      else if (x.dataIndex === "eventStatus") {
        colRenderer.Cell = MyEventRender
      }

      // Header Column 
      switch (x.dataIndex) {
        case "eventStatus": 
          // additionalStyle.backgroundColor = '#CAEDFB';
          colRenderer.Header = () => (<span style={additionalStyle}>{`My Events (${listCount})`}</span>);
          break;
        // case "containerNo": 
        //   additionalStyle.backgroundColor = '#F2CEEF';
        //   colRenderer.Header = () => (<span style={additionalStyle}>Container No</span>);
        //   break;
        // case "mblNo": 
        //   additionalStyle.backgroundColor = '#0000FF';
        //   additionalStyle.color = 'white';
        //   colRenderer.Header = () => (<span style={additionalStyle}>MBL No</span>);
        //   break;
        // case "te": 
        //   colRenderer.Header = () => (
        //     <span style={additionalStyle}>
        //       {<img height='18px' src={imgSrc} alt='' />}
        //     </span>);
        //   break;
        // case "cargo": 
        //   additionalStyle.backgroundColor = '#F2CEEF';
        //   colRenderer.Header = () => (<span style={additionalStyle}>Cargo</span>);
        //   break;
        // case "hblNo": 
        //   additionalStyle.backgroundColor = '#0000FF';
        //   additionalStyle.color = 'white';
        //   colRenderer.Header = () => (<span style={additionalStyle}>HBL No</span>);
        //   break;
        // case "pod": 
        //   additionalStyle.backgroundColor = '#FBE2D5';
        //   colRenderer.Header = () => (<span style={additionalStyle}>POD</span>);
        //   break;
        // case "eta": 
        //   additionalStyle.backgroundColor = '#DAF2D0';
        //   colRenderer.Header = () => (<span style={additionalStyle}>ETA</span>);
        //   break;
        // case "lastFreeDay": 
        //   additionalStyle.backgroundColor = '#C0E6F5';
        //   colRenderer.Header = () => (<span style={additionalStyle}>LFD</span>);
        //   break;
        // case "vesselArrivalDate": 
        //   additionalStyle.backgroundColor = '#00FF00';
        //   colRenderer.Header = () => (<span style={additionalStyle}>Vessel Arrival</span>);
        //   break;
        // case "unloadVesselDate": 
        //   additionalStyle.backgroundColor = '#F2CEEF';
        //   colRenderer.Header = () => (<span style={additionalStyle}>Unload from Vessel</span>);
        //   break;
        // case "railDepartureDate": 
        //   additionalStyle.backgroundColor = '#C0E6F5';
        //   colRenderer.Header = () => (<span style={additionalStyle}>Rail Departure</span>);
        //   break;
        // case "railArrivalDate": 
        //   additionalStyle.backgroundColor = '#B5E6A2';
        //   colRenderer.Header = () => (<span style={additionalStyle}>Rail Arrival</span>);
        //   break;
        case "anSentDate": 
          additionalStyle.backgroundColor = '#FF9BB3';
          additionalStyle.color = 'black';
          colRenderer.Header = () => (<span style={additionalStyle}>A/N Sent</span>);
          break;
        case "carrierRlsDate": 
          additionalStyle.backgroundColor = '#B3E5FC';
          additionalStyle.color = 'black';
          colRenderer.Header = () => (<span style={additionalStyle}>Carrier Rel.</span>);
          break;
        case "customsRlsDate": 
          additionalStyle.backgroundColor = '#BFB0E6';
          additionalStyle.color = 'black';
          colRenderer.Header = () => (<span style={additionalStyle}>Cust Rel.</span>);
          break;
        // case "pickupAvailableDate": 
        //   additionalStyle.backgroundColor = '#CAEDFB';
        //   colRenderer.Header = () => (<span style={additionalStyle}>Pickup Available</span>);
        //   break;
        case "pickupDate": 
          additionalStyle.backgroundColor = '#76933C';
          additionalStyle.color = 'black';
          colRenderer.Header = () => (<span style={additionalStyle}>Pickup</span>);
          break;
        case "emptyCntrRtnDate": 
          additionalStyle.backgroundColor = '#FFE59B';
          additionalStyle.color = 'black';
          colRenderer.Header = () => (<span style={additionalStyle}>Emp RTN</span>);
          break;
        case "billingsDate": 
          additionalStyle.backgroundColor = '#E26B0A';
          additionalStyle.color = 'black';
          colRenderer.Header = () => (<span style={additionalStyle}>Billings</span>);
          break;
        // case "consignee": 
        //   additionalStyle.backgroundColor = '#0000FF';
        //   additionalStyle.color = 'white';
        //   colRenderer.Header = () => (<span style={additionalStyle}>Consignee</span>);
        //   break;
        // case "trDate": 
        //   colRenderer.Header = () => (
        //   <span style={additionalStyle}>
        //     <img height='18px' src={imgSrc} alt='' />
        //     <span>Req Date</span>
        //   </span>);
        //   break;
      }

      return colRenderer;
    });
  }

   getExportRenderers(appContext : IApplicationContext): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });

    colRenderer.push({
      accessor: 'eventStatus', changedValue: (value: any) => {
        if (value['eventStatus'].includes(events.AnSent)) value['eventStatus'].replace(`${events.AnSent}`, 'A')
        if (value['eventStatus'].includes(events.CarrierRel)) value['eventStatus'].replace(`${events.CarrierRel}`, 'C')
        if (value['eventStatus'].includes(events.CustRel)) value['eventStatus'].replace(`${events.CustRel}`, 'R')
        if (value['eventStatus'].includes(events.Pickup)) value['eventStatus'].replace(`${events.Pickup}`, 'P')
        if (value['eventStatus'].includes(events.EmpRTN)) value['eventStatus'].replace(`${events.EmpRTN}`, 'E')
        if (value['eventStatus'].includes(events.Billings)) value['eventStatus'].replace(`${events.Billings}`, 'B')
        return value['eventStatus'];
      }
    });
     colRenderer.push({ accessor: 'anSentDate', changedValue: (value: any) => { return ExportEventDate('anSentDate', value, appContext) } });
     colRenderer.push({ accessor: 'lastFreeDay', changedValue: (value: any) => { return formatDate(value['lastFreeDay']) } });
     colRenderer.push({ accessor: 'vesselArrivalDate', changedValue: (value: any) => { return formatDate(value['vesselArrivalDate']) } });
     colRenderer.push({ accessor: 'unloadVesselDate', changedValue: (value: any) => { return formatDate(value['unloadVesselDate']) } });
     colRenderer.push({ accessor: 'railDepartureDate', changedValue: (value: any) => { return formatDate(value['railDepartureDate']) } });
     colRenderer.push({ accessor: 'railArrivalDate', changedValue: (value: any) => { return formatDate(value['railArrivalDate']) } });
     colRenderer.push({ accessor: 'carrierRlsDate', changedValue: (value: any) => { return ExportEventDate('carrierRlsDate', value, appContext) } });
     colRenderer.push({ accessor: 'customsRlsDate', changedValue: (value: any) => { return ExportEventDate('customsRlsDate', value, appContext) } });
     colRenderer.push({ accessor: 'pickupAvailableDate', changedValue: (value: any) => { return value['pickupAvailableDate'] } });
     colRenderer.push({ accessor: 'pickupDate', changedValue: (value: any) => { return ExportEventDate('pickupDate', value, appContext) } });
     colRenderer.push({ accessor: 'emptyCntrRtnDate', changedValue: (value: any) => { return ExportEventDate('emptyCntrRtnDate', value, appContext) } });
     colRenderer.push({ accessor: 'billingsDate', changedValue: (value: any) => { return ExportEventDate('billingsDate', value, appContext) } });
     return colRenderer;
   }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'mblId',
      orderByAscending: false,
     };
   }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings = myEventList;
    const cols = MyEventListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });

    return tsettings;
  }

  renderCommands(appContext: IApplicationContext) {
    let preparedBy = appContext.user?.id??'';
    const useDarkMode = appContext.useDarkMode;
    if (appContext.user?.isSuntekAdmin) {
      preparedBy = '';
    }

    return (
      <ListCommands useDarkMode={useDarkMode} preparedBy={preparedBy} />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar />
    );
  }

  renderExtras() {
    return (
      <ListViewExtras />
    );
  }

  renderRowExtras(rowId: number | null, context: IJobListViewContext, cell: any, appContext: any): React.ReactNode | null {
    
    if (!rowId || !cell) {
      return null;
    }

    function onClose() {
      context.setRowExtrasId(null);
    }

    function refreshView(dataIndex: string, row: any, date: string|null) {
      // OIH List
      let keyMatch = _.keys(fastStorage).find(x => x.startsWith('ifms-list-data-/common/joblistview/hbl/oceanImport'));
      if (keyMatch) {
        const listData = _.values(fastStorage[keyMatch]);
        listData.filter(x => x.id === row.hblId).forEach(row => {
          if (dataIndex === "anSentDate") {
            row.anPrtChk = !!date;
            row.anPrintedDate = date;
            context.updateDataRow(row);
          } else if (dataIndex === "customsRlsDate") {
            row.clearDate = date;
            context.updateDataRow(row);
          }
        });
      }
      // OIH Detail
      [`editOiHbl${row.hblId}-/oceanImport/hbl/edit`, `viewOiHbl${row.hblId}-/oceanImport/hbl/view`].forEach(key => {
        const keyMatch = _.keys(fastStorage).find(x => x.startsWith(key));
        if (keyMatch && fastStorage[keyMatch]) {
          fastStorage[keyMatch].clearDate = date;
          fastStorage[keyMatch].clearBy = date ? appContext.user?.id??'': '' ;
        }
      });

      // console.log(fastStorage);
      // OIM Detail
      if (dataIndex === "carrierRlsDate" && !row.mblCarrierRlsDate) {
        [`editOiMbl${row.mblId}-/oceanImport/mbl/edit`, `viewOiMbl${row.mblId}-/oceanImport/mbl/view`].forEach(key => {
          const keyMatch = _.keys(fastStorage).find(x => x.startsWith(key));
          if (keyMatch && fastStorage[keyMatch]) {
            fastStorage[keyMatch].rlsDate = date;
            fastStorage[keyMatch].rlsDateBy = date ? appContext.user?.id??'': '' ;
          }
        });
      }
    }

    function save(dataIndex: any, datePopupInputValue: string) {
      if (cell.value !== datePopupInputValue) {
        DoSave(cell.row.original, dataIndex, datePopupInputValue, appContext);
        onClose();
        context.reloadData();
        refreshView(dataIndex, cell.row.original, datePopupInputValue);
      }
      else
        onClose();
    }
    return <ContainerPopup onClose={onClose} save={save} cell={cell} />
  }

  getViewUrlFor() {
    return '';
  }

  hasMemo(): boolean {
    return false;
  }
  
  getListViewTitle() {
    return 'My Event List';
  };
}

export default MyEventListView;